import React, { useState, useEffect } from "react";
import { TimePeriod } from "../../Interfaces/Warehouse";
import { useNavigate } from "react-router-dom";
import "./FetchFundraisers.css";
import { FundraiserResponse } from "../../Interfaces/Fundraiser";
import config from "../../config";
import fetchWithAuth from "../../services/fetchWithAuth";

const BASE_API = config.API_BASE_URL;

interface FetchFundraisersComponentsProps {
  timePeriod: TimePeriod;
}

const fetchFundraisersFromApi = async (
  timePeriod: TimePeriod
): Promise<FundraiserResponse[]> => {
  try {
    let API_URL = `${BASE_API}fundraisers/all`;

    API_URL =
      timePeriod !== "ALL" ? `${API_URL}?active=${timePeriod}` : API_URL;

    const response = await fetchWithAuth(API_URL, {
      method: "GET", // Use POST or PUT if your API requires
      headers: {
        "Content-Type": "application/json",
        // Add authentication headers if required
        // Authorization: "Bearer YOUR_API_TOKEN", // Add token if required
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data as FundraiserResponse[];
  } catch (error) {
    console.error("Error fetching fundraisers:", error);
    throw error;
  }
};

// Main component
const FetchFundraisersComponents: React.FC<FetchFundraisersComponentsProps> = ({
  timePeriod,
}) => {
  const [fundraisers, setFundraisers] = useState<FundraiserResponse[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const navigate = useNavigate();

  const fetchFundraisers = async () => {
    setLoading(true);
    setError(null);

    try {
      const data = await fetchFundraisersFromApi(timePeriod);
      setFundraisers(data);
    } catch (err) {
      setError("Failed to fetch fundraisers.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFundraisers();
  }, [timePeriod]);

  const handleFundraiserClick = (
    id: number,
    fundraiser_name: string,
    brochure_only_account: number
  ) => {
    navigate(
      `/warehouse/orders/${id}?fundraiserName=${fundraiser_name}&brochureOnlyAccount=${brochure_only_account}`
    );
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="warehouse-order-page-fundraiser-item-list">
      {fundraisers.length > 0 ? (
        fundraisers.map((fundraiser) => (
          <div
            key={fundraiser.id}
            className="warehouse-order-page-fundraiser-item"
            onClick={() =>
              handleFundraiserClick(
                fundraiser.id,
                `${fundraiser.org_name} ${fundraiser.fundraiser_name}:`,
                fundraiser.brochure_only_account
              )
            }
          >
            <div className="warehouse-order-page-fundraiser-item-content">
              <h3>
                {fundraiser.org_name}: {fundraiser.fundraiser_name}
              </h3>
              <p>
                Start Date:{" "}
                {new Date(fundraiser.start_date).toLocaleDateString()}
              </p>
              <p>
                End Date: {new Date(fundraiser.end_date).toLocaleDateString()}
              </p>
            </div>
          </div>
        ))
      ) : (
        <div>No fundraisers found for the selected time period.</div>
      )}
    </div>
  );
};

export default FetchFundraisersComponents;
